import { render } from "./fileloader.vue?vue&type=template&id=ce82aad0&scoped=true"
import script from "./fileloader.vue?vue&type=script&lang=js"
export * from "./fileloader.vue?vue&type=script&lang=js"

import "./fileloader.vue?vue&type=style&index=0&id=ce82aad0&scoped=true&lang=css"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce82aad0"],['__file',"vue/js/components/shared/file_loader/fileloader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ce82aad0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ce82aad0', __exports__)) {
    console.log('reload')
    api.reload('ce82aad0', __exports__)
  }
  
  module.hot.accept("./fileloader.vue?vue&type=template&id=ce82aad0&scoped=true", () => {
    console.log('re-render')
    api.rerender('ce82aad0', render)
  })

}


export default __exports__